module.exports = __webpack_public_path__ + "static/images/instagram.f33b8db1835bc95b75923443c8de8783.svg";